import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { HiUserGroup, HiEyeOff } from 'react-icons/hi';
import { FaUserPlus, FaUserShield, FaUserCog, FaUserEdit } from 'react-icons/fa';
import { MdSwapVerticalCircle, MdBorderColor, MdDashboard } from 'react-icons/md';
import { SiHiveBlockchain } from 'react-icons/si';
import { RiSecurePaymentFill } from 'react-icons/ri';
import { useTranslation } from '../Context/LanguageContext';

const SidebarAdmin = (props) => {
  const { logoutHandle } = props;
  const { t } = useTranslation();

  return (
    <aside
      className='sidenav navbar navbar-vertical navbar-expand-xs fixed-start'
      id='AdminSidebar'
    >
      <div className='sidenav-header'>
        <i
          className='fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none'
          aria-hidden='true'
          id='iconSidenav'
        ></i>
        <Link
          to='/admin-dashboard'
          className='navbar-brand m-0 d-flex align-items-center justify-content-center'
        >
          <img
            src='https://www.hvambit.me/assets/logo.png'
            className='navbar-brand-img h-100'
            alt='main_logo'
          />
        </Link>
      </div>
      <hr className='horizontal light mt-0 mb-2' />
      <div
        className='collapse navbar-collapse w-auto h-auto'
        id='sidenav-collapse-main'
      >
        <ul className='navbar-nav'>
          <li className='nav-item'>
            <NavLink to='/admin-dashboard' className='nav-link'>
              <div className='icon'>
                <MdDashboard size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('dashboard')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/admin-transactions' className='nav-link'>
              <div className='icon'>
                <MdBorderColor size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('orders')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/customers' className='nav-link'>
              <div className='icon'>
                <HiUserGroup size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('customers')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/transfer-hvam-fiat' className='nav-link'>
              <div className='icon'>
                <RiSecurePaymentFill size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('hvamByMoney')}</span>
            </NavLink>
          </li>

          <li className='nav-item mt-3'>
            <h6 className='ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 text-gold'>
              {t('blockchainSetting')}
            </h6>
          </li>

          <li className='nav-item'>
            <NavLink to='/blockchain-setting' className='nav-link'>
              <div className='icon'>
                <SiHiveBlockchain size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('blockchainSetting')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/admin-setting' className='nav-link'>
              <div className='icon'>
                <FaUserEdit size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('adminSetting')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/admin-swapp' className='nav-link'>
              <div className='icon'>
                <MdSwapVerticalCircle size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('swapping')}</span>
            </NavLink>
          </li>

          <li className='nav-item mt-3'>
            <h6 className='ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 text-gold'>
              {t('systemSetting')}
            </h6>
          </li>

          <li className='nav-item'>
            <NavLink to='/users' className='nav-link'>
              <div className='icon'>
                <FaUserPlus size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('subAdmin')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/roles' className='nav-link'>
              <div className='icon'>
                <FaUserShield size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('rolePermission')}</span>
            </NavLink>
          </li>

          <li className='nav-item mt-3'>
            <h6 className='ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 text-gold'>
              {t('generalSetting')}
            </h6>
          </li>

          <li className='nav-item'>
            <NavLink to='/admin-profile' className='nav-link'>
              <div className='icon'>
                <FaUserCog size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('myProfile')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/admin-change-password' className='nav-link'>
              <div className='icon'>
                <HiEyeOff size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('changePassword')}</span>
            </NavLink>
          </li>

          <li className='d-block d-md-none px-2 mt-4'>
            <button
              type='button'
              onClick={() => logoutHandle()}
              className='btn btn-primary w-100'
            >
              {t('signOut')}
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default SidebarAdmin;
